import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const ptcolumn = [
  { field: "stt", headerName: "stt", width: 100, headerAlign: "center" },
  {
    field: "ten",
    headerName: "Tên phân nhóm phương tiện",
    width: 300,
    headerAlign: "center",
  },
  {
    field: "ma",
    headerName: "Mã phân nhóm phương tiện",
    width: 300,
    headerAlign: "center",
  },
];
const listnhomphuongtien = [
  { stt: "1", ten: "Ô tô từ 9 ghế trở xuống, Cthg", ma: "" },
  { stt: "2", ten: "Ô tô khách 10-24 ghế", ma: "" },
  { stt: "3", ten: "Ô tô khách 25-40 ghế", ma: "" },
  { stt: "4", ten: "Ô tô khách trên 40 ghế", ma: "" },
  { stt: "5", ten: "Ô tô tải đến 2T", ma: "" },
  { stt: "5", ten: "Ô tô tải trên 2T đến 7T", ma: "" },
];
export default function Danhmucphannhomphuongtien() {
  const [pageSize, setPageSize] = React.useState(50);
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };

  return (
    <GridContainer>
      <GridItem
        xs={12}
        sm={10}
        md={12}
        style={{ marginTop: 5, marginBottom: 10 }}
      >
        <Button color="primary" variant="contained" style={{ height: 27 }}>
          Thêm mới
        </Button>
        <Button
          variant="contained"
          style={{
            marginLeft: 10,
            color: "#fff",
            backgroundColor: "#BB2124",
            height: 27,
          }}
        >
          Xóa
        </Button>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.stt}
            rows={listnhomphuongtien}
            columns={ptcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
    </GridContainer>
  );
}
